import { Link } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";

// initial values
const initialValues = {
  name: "",
  email: "",
  message: "",
};

// yup validation schema
const validationSchema = Yup.object({
  name: Yup.string()
    .trim()
    .min(2, "Name must be at least 2 characters")
    .required("Name is required"),
  email: Yup.string()
    .email("Invalid email address")
    .required("Email is required"),
  message: Yup.string()
    .trim()
    .min(10, "Message must be at least 10 characters")
    .required("Message is required"),
});

export const Contact = (props) => {
  const handleSubmit = (values, { resetForm }) => {
    console.log(values);

    // emailjs integration here if needed

    resetForm();
  };

  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="col-md-8">
            <div className="row">
              <div className="section-title">
                <h2 style={{ color: "#333333" }}>Get In Touch</h2>
                <p style={{ color: "#777777" }}>
                  Please fill out the form below to send us an email and we will
                  get back to you as soon as possible.
                </p>
              </div>

              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
              >
                {({ isSubmitting }) => (
                  <Form noValidate>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <Field
                            type="text"
                            name="name"
                            className="form-control"
                            placeholder="Name"
                          />
                          <ErrorMessage
                            name="name"
                            component="p"
                            className="help-block text-danger"
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group">
                          <Field
                            type="email"
                            name="email"
                            className="form-control"
                            placeholder="Email"
                          />
                          <ErrorMessage
                            name="email"
                            component="p"
                            className="help-block text-danger"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="form-group">
                      <Field
                        as="textarea"
                        name="message"
                        rows="4"
                        className="form-control"
                        placeholder="Message"
                      />
                      <ErrorMessage
                        name="message"
                        component="p"
                        className="help-block text-danger"
                      />
                    </div>

                    <button
                      type="submit"
                      className="btn btn-custom btn-lg"
                      disabled={isSubmitting}
                      style={{ color: "#777777" }}
                    >
                      Send Message
                    </button>
                  </Form>
                )}
              </Formik>
            </div>
          </div>

          {/* Right Side Contact Info */}
          <div className="col-md-3 col-md-offset-1 contact-info">
            <div className="contact-item">
              <h3 style={{ color: "#777777" }}>Contact Info</h3>
              <p style={{ color: "#777777" }}>
                <span style={{ color: "#777777" }}>
                  <i className="fa fa-map-marker"></i> Address
                </span>
                {props.data ? props.data.address : "loading"}
              </p>
            </div>

            <div className="contact-item">
              <p style={{ color: "#777777" }}>
                <span style={{ color: "#777777" }}>
                  <i className="fa fa-phone"></i> Phone
                </span>
                {props.data ? props.data.phone : "loading"}
              </p>
              <p style={{ color: "#777777" }}>
                <span style={{ color: "#777777" }}>
                  <i className="fa fa-phone"></i> Secondary Phone
                </span>
                {props.data ? props.data.secondaryPhone : "loading"}
              </p>
            </div>

            <div className="contact-item">
              <p style={{ color: "#777777" }}>
                <span style={{ color: "#777777" }}>
                  <i className="fa fa-envelope-o"></i> Email
                </span>
                {props.data ? props.data.email : "loading"}
              </p>
            </div>
          </div>

          {/* Social */}
          <div className="col-md-12">
            <div className="row">
              <div className="social">
                <ul>
                  <li>
                    <a
                      href={props.data ? props.data.instagram : "/"}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fa fa-instagram"></i>
                    </a>
                  </li>
                  {/* <li>
                    <a href={props.data ? props.data.twitter : "/"}>
                      <i className="fa fa-twitter"></i>
                    </a>
                  </li> */}
                  <li>
                    <a
                      href={props.data ? props.data.youtube : "/"}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fa fa-youtube"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div id="footer" style={{ color: "#777777" }}>
        <div className="container text-center">
          <p>
            Copyright &copy; {new Date().getFullYear()}{" "}
            <Link to="/" rel="nofollow">
              iTreasure Kids
            </Link>{" "}
            | <Link to="/policy">Privacy Policy</Link> |{" "}
            <Link to="/terms">Terms & Conditions</Link>
          </p>
        </div>
      </div>
    </div>
  );
};
